import { Component, OnInit, AfterViewInit, OnDestroy, ComponentFactoryResolver, ChangeDetectorRef }
  from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { BreadcrumbModel } from '@shared/models/breadcrumb.model';
import {getQueryResponse} from '@shared/store/selectors/query.selector';
import { IQueryState } from '@shared/store/reducers/query.reducer';
import { QueryProvider } from '@shared/queries/query-provider';
import { Configuration } from '@shared/models/configuration';
import { DialogService } from '@shared/services/dialog-service';
import { DialogModel } from '@shared/models/dialog.model';
import { CommandService } from '@core/services/command.service';
import { Store, select } from '@ngrx/store';
import { Subject } from 'rxjs';
import { take, takeUntil } from 'rxjs/operators';
import { DataSurveyState } from '../../store/reducers/data-survey.reducers';
import { GetSurveyAction } from '../../store/actions/data-survey.actions';
import { getCurrentSurvey } from '../../store/selectors/data-survey.selectors';
import { ImportFieldSectionIntoDataSurveyCommand } from '../../commands/survey.commands';
import { CreateWorkflowAction } from '../../../workflow/store/workflow.actions';
import { getWorkflowReducerState, isWorkflowCleanedUp } from '../../../workflow/store/workflow.selector';
import {Guid} from 'guid-typescript';
import { PlatformCommand } from '@shared/commands/command-base';
import { FuseSplashScreenService } from '@barebone-fuse-services/splash-screen.service';

@Component({
    standalone: false,
    selector: 'particle-edit-survey',
  templateUrl: './edit-survey.component.html',
  styleUrls: ['./edit-survey.component.scss']
})
export class EditSurveyComponent implements OnInit, AfterViewInit, OnDestroy {
  surveyId: string;
  breadcrumbs: BreadcrumbModel[];
  breadcrumbs$: any;
  breadcrumbKey: string;
  survey: any;
  private ngUnsubscribe = new Subject<void>();
  selectedFieldSectionIndex: number;
  workflowId: string;
  apiEndpointKey: string;
  workflowState$: any;
  cleanedUp$: any;
  addExecutionModalData: any;
   dataExecutionId: string;
  constructor(protected store: Store<IQueryState>, protected activatedRoute: ActivatedRoute,
    private dataSurveyStore: Store<DataSurveyState>,
    private componentFactoryResolver: ComponentFactoryResolver,
    private changeDetector: ChangeDetectorRef,
    private dialogService: DialogService,
    private commandService: CommandService,
    private fuseSplashScreenService: FuseSplashScreenService,
    private router: Router
    ) {
      this.breadcrumbs = [
        <BreadcrumbModel>{
          id : 'DataSurvey',
          title: 'Data Survey',
          type: 'DataSurvey',
          relativeUrl: 'data-survey'
        }
      ];
      this.breadcrumbKey = 'BreadcrumbBySurveyId';
      this.selectedFieldSectionIndex = 0;
      this.workflowId = Guid.create().toString();
      this.apiEndpointKey = 'DataSurveyApi';
    }

  ngOnInit() {
    this.activatedRoute.params.subscribe((params: any) => {
      this.surveyId = params.surveyId;
      this.getCurrentSurvey();

      this.breadcrumbs$ = this.store.pipe(takeUntil(this.ngUnsubscribe), select(getQueryResponse, this.breadcrumbKey));
      this.breadcrumbs$.subscribe(state => {
        if (state) {
          this.breadcrumbs = [...state.breadcrumb];
          this.breadcrumbs.push(<BreadcrumbModel>{
            id : 'edit',
            title: 'Edit',
            type: 'DataSurvey',
            relativeUrl: `data-survey/${this.surveyId}/edit`
          });
        }
      });
      QueryProvider.invokeQuery(this.store, this.breadcrumbKey, {'[ID]': this.surveyId});
    });
    this.dataSurveyStore.pipe(takeUntil(this.ngUnsubscribe), select(getCurrentSurvey)).subscribe(currentSurvey => {
      console.log('current survey:', currentSurvey);
      if (currentSurvey && this.surveyId === currentSurvey.id) {
        const isFirstTime = !this.survey;
        this.survey = currentSurvey;
        if (isFirstTime) {
         // this.loadWorkflow();
          this.showAddExecutionSurvey();
        }
      }
    });




  }
  loadWorkflow() {
    if (!this.survey) {
      return;
    }
    const url = `${Configuration.getConfig(this.apiEndpointKey)}Command/CreateWorkflow`;
    const action = new CreateWorkflowAction(url, this.workflowId, 'Edit Data Survey', 'data-survey-edit-workflow', true);
    action.setParameters({
      'SurveyId': this.survey.id,
      'SurveyTitle': this.survey.title,
      'SurveyDescription': this.survey.description,
      'Title': this.addExecutionModalData.title,
      'IsCollaborative': this.addExecutionModalData.isIndividualResponse === false,
      'CanAddNewRow': this.addExecutionModalData.allowCreateNewRecord,
      'Description': this.addExecutionModalData.description,
    });

    this.store.dispatch(action);
    this.workflowState$ = this.store.pipe(select(getWorkflowReducerState, this.workflowId));
    this.workflowState$.subscribe(state => {
      console.log(state);
      if(state && state.workflow && state.workflow.States){
        let obj = state.workflow.States.find(x=>{
          return x.Id=="ExecutionDataStep";
        });
        if(obj && obj['Arguments'] && obj['Arguments']['DataExecutionId']){
          this.dataExecutionId = obj['Arguments']['DataExecutionId'] ;
        }

      }

    });
    this.cleanedUp$ = this.store.pipe(select(isWorkflowCleanedUp, this.workflowId));
    this.cleanedUp$.pipe(takeUntil(this.ngUnsubscribe)).subscribe(state => {
      if(state === 'Cancelled'){
        this.router.navigateByUrl(`data-survey/templates/${this.surveyId}/edit`);
      }
      else if (state === 'Finished') {
       if(this.dataExecutionId){
         this.openSurveyExecution(this.dataExecutionId);
       }
       else {
         console.error("dataExecutionId not found")
       }
      }
    });
  }
  private openSurveyExecution(executionId:string) {
    this.fuseSplashScreenService.show();
    const command = new PlatformCommand('CreateSurveyExecutionLinkCommand', 'DataSurveyApi');
    command.fieldValues['ExecutionId'] = executionId;
    command.fieldValues['ViewType'] = 'GridView';
    this.commandService.executePlatformCommand(command).pipe(take(1)).subscribe(response => {
        console.log('commandState', response);
        if (response.fieldValues['RedirectUrl']) {
          this.router.navigateByUrl(response.fieldValues['RedirectUrl']);
        }
      },
      error => {
        this.fuseSplashScreenService.hide();
        console.error('Failed openSurveyExecution ', error);
      });
  }
  getCurrentSurvey() {
    this.dataSurveyStore.dispatch(new GetSurveyAction(this.surveyId));
  }
  ngAfterViewInit() {
    // if (this.surveyQuestions && this.surveyQuestions.length) {
    //   this.renderReadyQuestions();
    // }
  }
  importFieldSections() {
    const dialogModel: DialogModel = DialogModel.create(
      'Import Field Sections',
      'ImportFieldSectionsComponent', { 'surveyId': this.surveyId },
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      if (res && res.action === 'OK') {
        console.log('import sections dialog:', res);
        const command = new ImportFieldSectionIntoDataSurveyCommand(this.surveyId);
        this.commandService.executeCommand(command)
          .pipe(takeUntil(this.ngUnsubscribe)).subscribe(commandState => {
          this.getCurrentSurvey();
        });
      }

    });
  }

  onAddQuestion() { // build purpose

  }
  onImportQuestion() { // build purpose

  }
  onTitleChange(event) { // build purpose

  }
  onDescriptionChange(event) { // build purpose

  }
  onTabIndexChange($event) {

  }
  ngOnDestroy() {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
  onGridCellValueChange($event) {

  }
  showAddExecutionSurvey() {
    const input = {
      title: this.survey.title,
      description: '',
      showResponseOption: false,
      isIndividualResponse: false
    };
    const dialogModel: DialogModel = DialogModel.create(
      'Create Data Survey',
      'AddExecutionDialogComponent', input,
      '600px',
      '700px'
    );
    this.dialogService.showOkCancelDialog(dialogModel).subscribe(res => {
      console.log(res);
      if (res && res.action === 'OK') {
        this.addExecutionModalData = res.data.input;
        this.loadWorkflow();
      } else {
        this.router.navigateByUrl(`data-survey/templates/${this.surveyId}/edit`);
      }
    });
  }
}
